import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  getRecoveryMethodError,
  getSelectedMailbox,
} from '../../../store/reducers/index';
import { ApplicationState } from '../../../store/reducers';
import { MailboxEntryData } from '../../models/mailboxes.model';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mprd-no-recovery-methods-container',
  templateUrl: 'no-recovery-methods-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoRecoveryMethodsContainerComponent implements OnInit, OnDestroy {
  passwordRecoveryMethodForm: UntypedFormGroup;
  showLoadingSpinner: boolean;
  $getRecoveryMethodError: Subscription;
  selectedValues: Array<string>;

  constructor(
    private builder: UntypedFormBuilder,
    private store: Store<ApplicationState>,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.createAnEmptyForm();
    this.setFormValidityStatusToInValid();

    this.$getRecoveryMethodError = this.store
      .select(getRecoveryMethodError)
      .subscribe(() => {
        this.showLoadingSpinner = false;
        this.changeDetector.markForCheck();
      });

    // for email input validation
    this.store
      .select(getSelectedMailbox)
      .subscribe((selectedMailbox: MailboxEntryData) => {
        this.selectedValues = [];
        if (selectedMailbox) {
          this.selectedValues.push(selectedMailbox.mbxId);

          if (Array.isArray(selectedMailbox.aliases)) {
            selectedMailbox.aliases.forEach((alias) => {
              this.selectedValues.push(alias.aliasId);
            });
          }
        }
      });
  }

  ngOnDestroy() {
    this.$getRecoveryMethodError.unsubscribe();
  }

  private updateMobileNumberInTheForm(mobile: string) {
    this.passwordRecoveryMethodForm.patchValue({ mobileNumber: mobile });
  }

  private updateMailIdInTheForm(mail: string) {
    this.passwordRecoveryMethodForm.patchValue({ mailId: mail });
  }

  private createAnEmptyForm() {
    this.passwordRecoveryMethodForm = this.builder.group({
      channel: ['sms', Validators.required],
      mobileNumber: [''],
      mailId: [''],
      formValidityStatus: ['', Validators.required],
    });
  }

  onMobileNumberInputFormStatusAndValue(mobileNumberFormStatusAndValue: {
    mobileNumberFormStatus: string;
    mobileNumber: string;
    errors: any;
  }) {
    if (mobileNumberFormStatusAndValue.mobileNumberFormStatus) {
      this.passwordRecoveryMethodForm.patchValue({
        mobileNumber: mobileNumberFormStatusAndValue.mobileNumber,
      });
      this.setFormValidityStatusToValid();
    } else {
      this.setFormValidityStatusToInValid();
    }
  }

  onValidEmail(inputFormGroup: UntypedFormGroup) {
    if (inputFormGroup.valid) {
      this.passwordRecoveryMethodForm.patchValue({
        mailId: inputFormGroup.get('mailId').value,
      });
      this.setFormValidityStatusToValid();
    } else {
      this.setFormValidityStatusToInValid();
    }
  }

  private setFormValidityStatusToInValid() {
    this.passwordRecoveryMethodForm.patchValue({ formValidityStatus: '' });
  }

  private setFormValidityStatusToValid() {
    this.passwordRecoveryMethodForm.patchValue({ formValidityStatus: 'valid' });
  }

  onChannelChange(channelValue) {
    this.setFormValidityStatusToInValid();
  }

  setPasswordRecovery() {
    this.showLoadingSpinner = true;
    switch (this.passwordRecoveryMethodForm.value.channel) {
      case 'mail': {
        this.store.dispatch(
          new RecoveryMethodsActions.SetEmailRecoveryMethodAction(
            this.passwordRecoveryMethodForm.value.mailId,
          ),
        );
        break;
      }
      case 'sms': {
        this.store.dispatch(
          new RecoveryMethodsActions.SetSmsRecoveryMethodAction(
            this.passwordRecoveryMethodForm.value.mobileNumber,
          ),
        );
      }
    }
  }
}
